<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card v-else min-width="350">
        <template v-if="payment.account.logo">
          <v-card-title class="py-4 text-center">
            <v-spacer />
            <v-sheet rounded outlined>
              <v-responsive class="align-center" :aspect-ratio="1/1">
                <v-sheet class="px-1" width="100">
                  <v-img :src="payment.account.logo" width="100%" />
                </v-sheet>
              </v-responsive>
            </v-sheet>
            <v-spacer />
          </v-card-title>
          <v-divider />
        </template>
        <v-card-subtitle>
          <v-toolbar class="mx-n2" color="transparent" flat height="18">
            <v-toolbar-items>
              <v-btn @click="$router.push({ name: 'PaymentRetrieve' })" text color="primary"><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-toolbar-items>
            <v-toolbar-title class="pl-4">
              <span class="body-1 text--secondary font-weight-medium">{{payment.balance | currency(payment.currency)}} {{payment.currency}}<v-icon color="secondary">mdi-circle-small</v-icon>{{payment.description}}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="background">
          <v-row no-gutters align="center" justify="start">
            <v-col cols="6" sm="4" md="4" lg="4" class="py-1">
              <span class="ml-1 font-weight-medium">RUT del pagador</span>
              <v-text-field v-model="$v.fields.docNumberMasked.$model" v-dni="'CL'" :error="$v.fields.docNumberMasked.$error || $v.fields.docNumber.$error" background-color="white" outlined required single-line dense maxlength="12" persistent-hint hide-details />
            </v-col>
            <v-col cols="12" class="py-1">
              <span class="ml-1 font-weight-medium">Titular de la tarjeta</span>
              <v-text-field v-model="$v.fields.cardholderName.$model" :error="$v.fields.cardholderName.$error" background-color="white" outlined required single-line dense maxlength="80" persistent-hint hide-details />
            </v-col>
            <v-col cols="12" sm="6" md="7" lg="7" class="py-1">
              <span class="ml-1 font-weight-medium">Número de la tarjeta</span>
              <v-text-field v-model="$v.fields.cardNumberMasked.$model" v-mask="'#### #### #### ####'" :error="$v.fields.cardNumberMasked.$error" background-color="white" outlined required single-line dense maxlength="19" persistent-hint hide-details>
                <template v-if="brand" v-slot:append>
                  <v-fade-transition leave-absolute>
                    <img class="mr-2" :src="require(`@/assets/appAsset-cardbrand--${brand}.svg`)" :alt="brand" height="20" />
                  </v-fade-transition>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="py-1">
              <span class="ml-1 font-weight-medium">Vencimiento</span>
              <v-text-field v-model="$v.fields.cardExpirationMasked.$model" v-mask="'##/##'" :error="$v.fields.cardExpirationMasked.$error || $v.fields.cardExpirationMonth.$error || $v.fields.cardExpirationYear.$error" placeholder="MM/AA" background-color="white" outlined required single-line dense maxlength="5" persistent-hint hide-details />
            </v-col>
            <v-col cols="6" sm="3" md="2" lg="2" class="py-1">
              <span class="ml-1 font-weight-medium">CVV</span>
              <v-text-field v-model.number="$v.fields.securityCode.$model" :error="$v.fields.securityCode.$error" background-color="white" outlined required single-line dense maxlength="3" persistent-hint hide-details />
            </v-col>
            <form id="mercadopagoForm"></form>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 background">
          <v-row align="center" justify="start">
            <v-col cols="12">
              <v-btn @click="pay" :style="{'background-color': `${payment.account.color_background} !important`}" :loading="loaderPay" height="40" block dark>Pagar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, maxValue, minLength, minValue, numeric, required } from 'vuelidate/lib/validators'
import { rutValidator } from 'vue-dni'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import GatewayViewMixin from '@/mixins/GatewayViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  name: 'piriod-gateway-mercadopago',
  inject: ['theme'],
  components: {
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GatewayViewMixin,
    GenericViewMixin
  ],
  data: () => ({
    brand: '',
    brands: {
      amex: 'AmericanExpress',
      debmaster: 'MasterCard',
      debvisa: 'Visa',
      diners: 'Diners',
      master: 'MasterCard',
      redcompra: 'RedCompra',
      visa: 'Visa'
    },
    fields: {
      cardExpirationMasked: '',
      cardExpirationMonth: null,
      cardExpirationYear: null,
      cardholderName: '',
      cardNumber: null,
      cardNumberMasked: '',
      docNumber: '',
      docNumberMasked: '',
      docType: 'RUT',
      securityCode: null
    }
  }),
  computed: mapState({
    payment: state => cloneDeep(state.payments.payDetail),
    source: state => cloneDeep(state.payments.sourcesDetail),
    paymentsDetail: state => state.payments.paymentsDetail
  }),
  watch: {
    'fields.cardExpirationMasked' () {
      if (this.fields.cardExpirationMasked) {
        const cardExpiration = this.fields.cardExpirationMasked.split('/')
        this.$v.fields.cardExpirationMonth.$model = this.fields.cardExpirationMonth = Number(cardExpiration[0])
        this.$v.fields.cardExpirationYear.$model = this.fields.cardExpirationYear = Number(cardExpiration[1])
      }
    },
    'fields.cardNumberMasked' () {
      if (this.fields.cardNumberMasked) {
        this.$v.fields.cardNumber.$model = this.fields.cardNumberMasked.replace(/\s/g, '')
      }
      if ([6, 15, 16].includes(this.fields.cardNumber.length)) {
        window.Mercadopago.getPaymentMethod({
          bin: this.fields.cardNumber.substring(0, 6)
        }, (status, response) => {
          if (status === 200) {
            this.brand = this.brands[response[0].id] || ''
          } else {
            this.brand = ''
          }
        })
      }
    },
    'fields.docNumberMasked' () {
      if (this.fields.docNumberMasked) {
        this.$v.fields.docNumber.$model = this.fields.docNumberMasked.replace(/\./g, '')
      }
    }
  },
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .then(() => {
      if (this.payment.status === 'succeeded' || !this.payment.gateways.includes('mercadopago')) {
        this.$router.push({ name: 'PaymentRetrieve' })
      }
      window.Mercadopago.setPublishableKey(this.payment.merchants.mercadopago)
      window.Mercadopago.getIdentificationTypes()
    })
  },
  methods: {
    pay () {
      this.$v.fields.$touch()
      if (this.$v.fields.$invalid) {
        return false
      }
      this.loaderPay = true
      const mercadopagoForm = document.getElementById('mercadopagoForm')
      while (mercadopagoForm.firstChild) {
        mercadopagoForm.firstChild.remove()
      }
      const fields = [
        'cardholderName',
        'cardNumber',
        'cardExpirationMonth',
        'cardExpirationYear',
        'docNumber',
        'docType',
        'securityCode'
      ]
      fields.forEach((f) => {
        const domField = window.document.createElement('input')
        domField.setAttribute('data-checkout', f)
        domField.setAttribute('id', f)
        domField.setAttribute('type', 'hidden')
        domField.setAttribute('value', this.fields[f])
        mercadopagoForm.appendChild(domField)
      })
      const processPay = async (status, response) => {
        if ([200, 201].includes(status)) {
          await this.createSource('mercadopago', { token: response.id })
          await this.authorizePayment()
          await this.capturePayment()
        } else {
          this.loaderPay = false
          return false
        }
        this.$router.push({ name: 'PaymentRetrieve' })
      }
      window.Mercadopago.createToken(mercadopagoForm, processPay)
    }
  },
  validations: {
    fields: {
      cardExpirationMasked: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      cardExpirationMonth: {
        required,
        maxLength: maxLength(2),
        maxValue: maxValue(12),
        minLength: minLength(1),
        minValue: function (val) {
          const currentYear = Number(moment().format('YY'))
          if (this.fields.cardExpirationYear <= currentYear) {
            return val >= Number(moment().format('MM'))
          }
          return true
        },
        numeric
      },
      cardExpirationYear: {
        required,
        maxLength: maxLength(2),
        maxValue: maxValue(31),
        minLength: minLength(2),
        minValue: minValue(Number(moment().format('YY'))),
        numeric
      },
      cardholderName: {
        required,
        maxLength: maxLength(80)
      },
      cardNumber: {
        required,
        maxLength: maxLength(16),
        numeric
      },
      cardNumberMasked: {
        required,
        maxLength: maxLength(19),
        minLength: minLength(15)
      },
      docNumber: {
        required,
        maxLength: maxLength(10),
        taxId: function (val) {
          return rutValidator(val)
        }
      },
      docNumberMasked: {
        required,
        maxLength: maxLength(12)
      },
      securityCode: {
        required,
        maxLength: maxLength(3)
      }
    }
  }
}
</script>